import warning from 'warning';
import { indigo, pink, grey, red, green, cyan, amber, black, white, } from './colors';
import getContrastRatio from './getContrastRatio';
export var light = {
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.38)',
        hint: 'rgba(0, 0, 0, 0.38)',
        icon: 'rgba(0, 0, 0, 0.38)',
        divider: 'rgba(0, 0, 0, 0.12)',
        lightDivider: 'rgba(0, 0, 0, 0.075)',
        snackbar: 'rgba(255,255,255,0.87)',
    },
    input: {
        bottomLine: 'rgba(0, 0, 0, 0.42)',
        helperText: 'rgba(0, 0, 0, 0.54)',
        labelText: 'rgba(0, 0, 0, 0.54)',
        inputText: 'rgba(0, 0, 0, 0.87)',
        disabled: 'rgba(0, 0, 0, 0.42)',
    },
    action: {
        active: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.26)',
        hover: 'rgba(0, 0, 0, 0.08)',
        selected: 'rgba(0, 0, 0, 0.14)',
    },
    background: {
        default: grey[50],
        paper: white,
        appBar: grey[100],
        contentFrame: grey[200],
        divider: grey[200],
        chips: grey[300],
        chipsImg: grey[400],
        chipsBut: grey[400],
        chipsButHover: grey[500],
        tooltip: grey[600],
        transparent: 'rgba(0,0,0,0)',
        sendcondaryTransparent: 'rgba(255,255,255,0.87)',
        snackbar: black,
    },
};
export var dark = {
    text: {
        primary: 'rgba(255, 255, 255, 1)',
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)',
        divider: 'rgba(255, 255, 255, 0.12)',
        lightDivider: 'rgba(255, 255, 255, 0.075)',
        snackbar: 'rgba(0,0,0,0.87)',
    },
    input: {
        bottomLine: 'rgba(255, 255, 255, 0.7)',
        helperText: 'rgba(255, 255, 255, 0.7)',
        labelText: 'rgba(255, 255, 255, 0.7)',
        inputText: 'rgba(255, 255, 255, 1)',
        disabled: 'rgba(255, 255, 255, 0.5)',
    },
    action: {
        active: 'rgba(255, 255, 255, 1)',
        disabled: 'rgba(255, 255, 255, 0.3)',
        hover: 'rgba(255, 255, 255, 0.2)',
        selected: 'rgba(255, 255, 255, 0.14)',
    },
    background: {
        default: '#303030',
        chipsButHover: grey[400],
        chipsBut: grey[500],
        chipsImg: grey[600],
        tooltip: grey[700],
        chips: grey[700],
        paper: grey[800],
        appBar: grey[900],
        contentFrame: grey[900],
        status: black,
        sendcondaryTransparent: 'rgba(0,0,0,0.87)',
        snackbar: white,
        transparent: 'rgba(255, 255, 255)',
        divider: grey[200],
    },
};
export default function createPalette(options) {
    if (options === void 0) { options = {}; }
    var _a = options.primary, primary = _a === void 0 ? indigo : _a, _b = options.accent, accent = _b === void 0 ? pink : _b, _c = options.error, error = _c === void 0 ? red : _c, _d = options.success, success = _d === void 0 ? green : _d, _e = options.info, info = _e === void 0 ? cyan : _e, _f = options.warning, warningColor = _f === void 0 ? amber : _f, _g = options.danger, danger = _g === void 0 ? red : _g, _h = options.type, type = _h === void 0 ? 'light' : _h, _j = options.contrastThreshold, contrastThreshold = _j === void 0 ? 3 : _j;
    var shades = { dark: dark, light: light };
    /**
     * 获取文本对比色
     *
     * @param background 文本的背景色
     */
    function getContrastText(background) {
        var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold
            ? dark.text.primary
            : light.text.primary;
        if (process.env.NODE_ENV !== 'production') {
            var contrast = getContrastRatio(background, contrastText);
            warning(contrast >= contrastThreshold, [
                "sinoui: " + contrastText + "\u548C" + background + "\u4E4B\u95F4\u7684\u5BF9\u6BD4\u5EA6\u662F" + contrast + ":1\uFF0C",
                '不满足WACG推荐的对比度值3:1。',
                'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast',
            ].join('\n'));
        }
        return contrastText;
    }
    return {
        type: type,
        shades: shades,
        text: shades[type].text,
        input: shades[type].input,
        action: shades[type].action,
        background: shades[type].background,
        primary: primary,
        accent: accent,
        error: error,
        success: success,
        info: info,
        warning: warningColor,
        danger: danger,
        grey: grey,
        white: white,
        black: black,
        getContrastText: getContrastText,
    };
}
//# sourceMappingURL=palette.js.map